/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-23 17:12:12
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-16 17:02:13
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorTabbar/TabModal/index.tsx
 */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getI18nFromGeneral } from '@/src/tools/tools';

import LinkLibrary from '@/src/constrains/LinkLibrary';
import { TabBarItem } from '@/src/types/common/SalesChannel';
import { Modal, Input } from '@/src/components/Antd';
import { ItemWrapper, Uploader } from '@/src/components';
import { getContentUuid } from '../slice';

import styles from './style.module.less';
import { Button } from 'antd';
import { uuid } from '@/src/tools/helper';
import { ILinkModule } from '@/src/types/common/linkType';
import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';

type Props = {
  visible: boolean;
  isAdd?: boolean;
  data?: TabBarItem;
  onSubmit: (data: TabBarItem) => void;
  onCancel: () => void;
  onReset?: () => void;
  hideLink?: boolean;
};

function TabModal({
  visible,
  isAdd,
  data,
  onSubmit,
  onCancel,
  onReset,
  hideLink,
}: Props) {
  const contentUuid = useSelector(getContentUuid());
  const linkSet = useSalesChannelGeneralLinkSet({ contentUuid });
  const [value, setValue] = useState<string>(
    !isAdd ? (data ? data.title : '') : '',
  );
  const [fileList, setFileList] = useState<Array<any>>(
    !isAdd ? (data ? (data.icon ? [data.icon] : []) : []) : [],
  );

  const [link, setLink] = useState(
    !isAdd ? (data ? data.link : ({} as ILinkModule)) : ({} as ILinkModule),
  );
  const [titleError, setTitleError] = useState('');
  const [linkError, setLinkError] = useState('');
  const [imageError, setImageError] = useState('');
  const handleChange = (value: string) => {
    setValue(value);
    if (!value && fileList.length === 0) {
      setTitleError('Tab title and tab icon cannot be both empty.');
    } else {
      setTitleError('');
    }
  };

  const handleIconChange = (list: Array<any>) => {
    const length = list.length;
    const item = length ? list[length - 1] : null;
    setFileList(item ? [item] : []);
    if (!value && !item) {
      setImageError('Tab title and tab icon cannot be both empty.');
    } else {
      setImageError('');
    }
  };

  const handleLinkChange = (link: any) => {
    setLink(link);
    if (!link.linkType) {
      setLinkError('Tab link cannot be empty.');
    } else {
      setLinkError('');
    }
  };

  const handleSubmit = () => {
    if (isAdd) {
      onSubmit({
        draggableId: uuid(),
        title: value,
        icon: fileList[0] || null,
        link,
        isHome: false,
      });
    } else {
      onSubmit({
        ...data,
        title: value,
        link,
        icon: fileList[0] || null,
      });
    }
  };
  const disabled = !(link || {}).linkType || (!value && fileList.length === 0);

  useEffect(() => {
    setValue(!isAdd ? (data ? data.title : '') : '');
    setFileList(!isAdd ? (data ? (data.icon ? [data.icon] : []) : []) : []);
    setLink(
      !isAdd ? (data ? data.link : ({} as ILinkModule)) : ({} as ILinkModule),
    );
  }, [data, isAdd]);

  return (
    <Modal
      width={600}
      visible={visible}
      title={isAdd ? 'Add New Tab' : 'Edit Tab'}
      okText={getI18nFromGeneral('general.antd.Modal.ModalFooter.confirm')}
      cancelText={getI18nFromGeneral('general.commonHeader.discard_text')}
      onOk={handleSubmit}
      onCancel={onCancel}
      afterClose={onReset}>
      <div className={styles.container}>
        <ItemWrapper
          containerClassName={styles.item}
          title={'Title'}
          error={!!titleError}
          errorText={titleError}
          rightSubTitle={'At most 8 characters or letters'}>
          <Input
            className={styles.input}
            value={value}
            onChange={handleChange}
            maxLength={8}
          />
        </ItemWrapper>
        {!hideLink && (
          <ItemWrapper
            containerClassName={styles.item}
            error={!!linkError}
            errorText={linkError}
            title={'Link*'}
            rightSubTitle={'Search or select a link for the tab item'}>
            <LinkLibrary
              mode={'no-modal'}
              title={''}
              containerClassName={styles.linkContainerClassName}
              linkSet={linkSet}
              id={data ? data.draggableId : ''}
              data={link}
              onChange={handleLinkChange}
            />
          </ItemWrapper>
        )}

        <ItemWrapper
          containerClassName={styles.item}
          title={'Icon'}
          error={!!imageError}
          errorText={imageError}
          rightSubTitle={'81px * 81px, allowed file types: jpeg, png, svg'}>
          <div className={styles.uploader}>
            <Uploader
              height={180}
              multiple={false}
              fileList={fileList}
              onChange={handleIconChange}
            />
          </div>
        </ItemWrapper>
        <div className={styles.footer}>
          <Button className={styles.btn} onClick={onCancel}>
            Discard
          </Button>
          <Button
            type='primary'
            className={styles.btn}
            onClick={handleSubmit}
            disabled={disabled}>
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default TabModal;
